import { useState } from 'react';
import { X } from 'lucide-react';

interface Props {
  onConfirm: (comment: string) => void;
  onClose: () => void;
  pending: boolean;
}

export function RejectCommentDialog({ onConfirm, onClose, pending }: Props) {
  const [comment, setComment] = useState('');
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[60] p-4" onClick={onClose}>
      <div className="bg-white rounded-xl shadow-xl w-full max-w-md" onClick={(e) => e.stopPropagation()}>
        <header className="flex items-center justify-between px-5 py-4 border-b border-neutral-200">
          <h3 className="font-heading text-lg font-semibold text-cime-text-primary">Motif du renvoi</h3>
          <button onClick={onClose} className="text-neutral-400 hover:text-neutral-700">
            <X className="w-4 h-4" />
          </button>
        </header>
        <div className="px-5 py-4">
          <textarea
            autoFocus
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            rows={4}
            placeholder="Motif global (obligatoire). Les marques déjà posées sur le PDF restent visibles à part."
            className="w-full border border-neutral-200 rounded-md px-3 py-2 text-sm"
          />
        </div>
        <footer className="flex items-center justify-end gap-2 px-5 py-3 border-t border-neutral-200">
          <button onClick={onClose} className="text-sm px-3 py-1.5 text-cime-text-muted hover:text-neutral-900">
            Annuler
          </button>
          <button
            onClick={() => onConfirm(comment.trim())}
            disabled={!comment.trim() || pending}
            className="text-sm px-3 py-1.5 rounded-md bg-red-600 text-white hover:opacity-90 disabled:opacity-40"
          >
            Renvoyer
          </button>
        </footer>
      </div>
    </div>
  );
}
